module.exports = __webpack_public_path__ + "img/colored-face.b4f6e02b.svg";